import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind-aware className merge utility used by every shadcn primitive.
 * Lifted from apps/frontend/src/lib/utils.ts so the shared package is
 * self-contained and doesn't reach into a consuming app.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
